module.exports = __webpack_public_path__ + "static/img/2-09.596aefa.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/2-09.png
// module id = 226
// module chunks = 0